import { NgModule } from '@angular/core';
import { HomePageRoutingModule } from './home-page-routing.module';

@NgModule({
  imports: [
    HomePageRoutingModule
  ]
})
export class HomePageModule { }
